<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title
				:title="getMessage_(screen.menuTitle)"
				useFaivorite
				:faivorite="screen.favoriteYn === 'Y'"
				:onFavorite="onFavorite"
			/>
		</template>
		<template v-slot:button>
			<sf-button size="lg" color="default" :line="false" className="sf-button--black-light" :action="Save">Save</sf-button>
		</template>
		<template v-slot:content>
			<content-view ref="content" :scrId="scrId"></content-view>
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import ContentView from './Content/ContentView.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
		console.clear();
	},
	components: {
		ContentView
	},
	computed: {
		...rootComputed,
		locations() {
			let result = [];
			if (this.screen?.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},

	methods: {
		...rootMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) || header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
